import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
declare var jQuery: any;
import "../../../../assets/semantic/semantic.min.js";
import { WarehouseService } from "../../../_services/warehouse.service";


@Component({
  selector: "app-edit-warehouse",
  templateUrl: "./edit-warehouse.component.html",
  styleUrls: ["./edit-warehouse.component.css"],
})
export class EditWarehouseComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private updating_warehouse = false;
  private warehouse_id: number;
  private edit_warehouses: object[]; 

  constructor(private warehouseService: WarehouseService) {}

  edit_warehouse = new FormGroup({
    name: new FormControl("", [Validators.required]),
    note: new FormControl('')
  });

  ngOnInit() {
  
    let warehouse_params = {full: true};
    this.warehouseService.getWarehouses(warehouse_params).subscribe((response) => {
      this.edit_warehouses = response.cities;
    });
  }

  openModal(warehouse) {
    this.warehouse_id = warehouse.id; // Set the Contact_id needed in the Update Contact URL
    this.edit_warehouse.patchValue({
      // Fill the FormGroup
      name: warehouse.name,
      note: warehouse.note
    });

     

    jQuery("#edit-warehouse-modal").modal({ inverted: true }).modal("show"); // Show the Modal
  }

  // Update Company
  submitWarehouseForm() {
    this.edit_warehouse.disable(); // Disable the form to avoid changes during the Updating process
    this.updating_warehouse = true; // Trigger the Loading button apparition
    jQuery("#edit-warehouse-modal").modal({ closable: false }); // Set the modal unclosable during the Updating process
    // Create the Contact
    this.warehouseService.updateWarehouse(this.warehouse_id, this.edit_warehouse.value).subscribe((response) => {
        jQuery("#edit-warehouse-modal").modal({ closable: true }).modal("hide"); // Set the modal closable & Close the modal
        this.updating_warehouse = false; // Disable the loading button apparition
        this.edit_warehouse.enable(); // Re Enable the Form
        this.edit_warehouse.reset(); // Reset It
        this.refresh.emit(true); // Emmit the refresh Event
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/warehouse/edit-warehouse/edit-warehouse.component.ts